import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import Layout from "components/sales/layout/layout";
import Images from "assets/images/imageData";
import { Link } from "react-router-dom";
import localization from "assets/localization/localization";
import SiteFeature from "components/sales/formSection/siteFeature/siteFeature";
import GateSetup from "components/sales/formSection/gatesSetup/gatesSetup";
import ParkingDetails from "components/sales/formSection/parkingDetails/parkingDetails";
import LaneDetails from "components/sales/formSection/laneDetails/laneDetails";
import FacilitiesInVicinity from "components/sales/formSection/facilitiesInVicinity/facilitiesInVicinity";
import RestaurantDetails from "components/sales/formSection/restaurantDetails/restaurantDetails";
import ModalPop from "components/sales/modal/modal";

const PreSalesSupply = ({
  match,
  getDropDownValues,
  dropDownList,
  savePresalesSupply,
  imageUploadUrl,
}) => {
  const supplyInput = {
    lead_id: null,
    siteFeature: null,
    GateSetup: null,
    LaneDetails: null,
    FacilitiesInVicinity: null,
    RestaurantDetails: null,
    ParkingDetails: null,
  };
  const data = {};

  const [leadId, setLeadId] = useState("");
  const [supplyData, setSupplyData] = useState(supplyInput);
  const [isFiled, setIsFiled] = useState(false);
  const [allFilled, setAllFilled] = useState(false);
  const [supData, setsupData] = useState(data);
  const [isModal, setIsModal] = useState(false);
  const [success, setSucess] = useState();

  const handleSiteFeatureSubmit = (val) =>
    setSupplyData({ ...supplyData, siteFeature: val });

  const handleGateSetupSubmit = (val) =>
    setSupplyData({ ...supplyData, GateSetup: val });

  const handleLaneDetailsSubmit = (val) =>
    setSupplyData({ ...supplyData, LaneDetails: val });

  const handleFacilitiesInVicinitySubmit = (val) =>
    setSupplyData({ ...supplyData, FacilitiesInVicinity: val });

  const handleRestaurantDetailsSubmit = (val) =>
    setSupplyData({ ...supplyData, RestaurantDetails: val });

  const handleParkingDetailsSubmit = (val) =>{
    setSupplyData({ ...supplyData, ParkingDetails: val });}
  const handleModalhide = () => setIsModal(false);

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.submitDtl}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };

  const handleSubmit = () => {
    const {
      siteFeature,
      GateSetup,
      LaneDetails,
      FacilitiesInVicinity,
      RestaurantDetails,
      ParkingDetails,
    } = supplyData;
    if (
      siteFeature === null ||
      RestaurantDetails === null ||
      ParkingDetails === null ||
      GateSetup === null ||
      LaneDetails === null ||
      FacilitiesInVicinity === null
    ) {
      setIsFiled(true);
      setAllFilled(false);
      return false;
    } else {
      setIsFiled(false);
      setAllFilled(true);
      setsupData({
        lead_id: leadId,
        ...siteFeature,
        ...GateSetup,
        ...LaneDetails,
        ...RestaurantDetails,
        ...FacilitiesInVicinity,
        ...ParkingDetails,
      });
    }
  };

  useEffect(() => {
    setLeadId(match.params.id);
    setSupplyData({ ...supplyData, ParkingDetails: leadId });
    setsupData({ ...supplyData, ParkingDetails: leadId });
    setIsModal(false);
  }, []);

  useEffect(() => {
    (async () => {
      if (allFilled === true) {
        const res = await savePresalesSupply(supData);
        if (res) {
          setIsModal(true);
        }
      }
    })();
  }, [allFilled]);

  useEffect(() => {
    if (getDropDownValues !== null && leadId)
      (async () => await getDropDownValues(leadId))();
  }, [getDropDownValues, leadId]);

  return (
    <Layout
      title={localization.preSalesSupplyTitle}
      className={isFiled ? "requiredFileds" : ""}
      Buttons={headerBtns}
      isGoback
    >
      <SiteFeature data={dropDownList} handleValue={handleSiteFeatureSubmit} />
      <GateSetup data={dropDownList} handleValue={handleGateSetupSubmit} />
      <LaneDetails handleValue={handleLaneDetailsSubmit} />
      <FacilitiesInVicinity handleValue={handleFacilitiesInVicinitySubmit} />
      <RestaurantDetails
        data={dropDownList}
        handleValue={handleRestaurantDetailsSubmit}
      />
      <ParkingDetails
        data={dropDownList}
        handleValue={handleParkingDetailsSubmit}
        imageUploadUrl={imageUploadUrl}
      />

      <ModalPop
        backdrop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalhide}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.PreSalesSuccess}</h5>
          <Link
            to="/dashboard/postSalesListing"
            className="btn btn-primary mb-4"
          >
            {localization.preSalesB2bList} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default PreSalesSupply;
